export interface ProductProductType {
  unitOfMeasureId: string;
  returnableProduct: boolean;
}
